import Page from '../../components/layouts/page'
import CategoriesTable from '../../components/categories_table'
import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { Button } from '@cinesend/ui-kit'
import useStore from '../../hooks/use_store'
import axios from 'axios'
import openInNewTab from '../../helpers/openinnewtab'
import { useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import CreateForm from './create_form'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../../components/disabled_tooltip'

const Categories = ({ categoryType = 'assets' }) => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const { createModel } = useStore()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const { data: airline } = useQuery(['airlines/', params.airlineID])
  const { data: cycle } = useQuery(['cycles/', params.cycleID])
  const langID = airline?.languages?.[0]?.id || null
  const queryClient = useQueryClient()
  const queryKey = `/categories?cycleID=${params.cycleID}`
  const { canEditModel: canEditCategory } = useAuth(modelTypes.Category)
  const isSection = categoryType === 'categories'

  if (!isSection && searchParams.get('type') === 'categories') {
    return <Navigate to={`/airlines/${params.airlineID}/cycles/${params.cycleID}/sections`} replace />
  }

  const closeModal = () => {
    setIsModalOpen(false)
    queryClient.invalidateQueries([queryKey])
  }

  const exportCategories = ({ isTemplate }) => {
    createModel.mutate(
      {
        endpoint: 'exports',
        data: {
          name: `export-cycle-${params.cycleID}-type-category`,
          cycleID: params.cycleID,
          type: 'category',
          isTemplate,
          langID,
        },
      },
      {
        onSuccess: (res) => {
          if (res.data) {
            axios.get(`${process.env.VITE_API_URL}/exports/${res.data.export.id}/download`).then((r) => {
              openInNewTab(r.data.url)
            })
          }
        },
      }
    )
  }
  return (
    <Page
      title={isSection ? 'Sections' : 'Categories'}
      buttons={[
        <div key={'asset-buttons'} className='space-x-2 flex items-center'>
          {isSection && canEditCategory && (
            <DisabledTooltip reason={cycle?.is_locked ? DISABLED_REASONS.cycleClosed : null}>
              <Button disabled={!!cycle?.is_locked} onClick={() => setShowCreateModal('categories')}>
                Create Section
              </Button>
            </DisabledTooltip>
          )}
          {!isSection && (
            <DisabledTooltip reason={cycle?.is_locked ? DISABLED_REASONS.cycleClosed : null}>
              <Button disabled={!!cycle?.is_locked} onClick={() => setShowCreateModal('assets')}>
                Create category
              </Button>
            </DisabledTooltip>
          )}
          {/* <ButtonDropdown
            button={{
              text: 'Export',
              icon: 'cloud_download',
            }}
            dropdown={{
              content: [
                {
                  text: 'Export Template',
                  onClick: () => exportCategories({ isTemplate: true }),
                },
                {
                  text: 'Export Populated',
                  onClick: () => exportCategories({ isTemplate: false }),
                },
              ],
            }}
          />
          <Button icon='cloud_upload' onClick={() => setIsModalOpen(true)}>
            import
          </Button> */}
        </div>,
      ]}
    >
      <CategoriesTable queryKey={queryKey} categoryType={categoryType} />
      {/* {isModalOpen && (
        <ImportForm isOpen={isModalOpen} onClose={closeModal} cycleID={params.cycleID} assetType={'category'} />
      )} */}
      {!!showCreateModal && (
        <CreateForm
          onClose={() => setShowCreateModal(false)}
          cycleID={params.cycleID}
          createModel={createModel}
          categoryType={showCreateModal}
        />
      )}
    </Page>
  )
}

export default Categories
